<template>
  <div class="app-container">
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
      <el-form-item label="选择用户" prop="user_uuid">
        <el-select
          v-model="ruleForm.user_uuid"
          filterable
          remote
          reserve-keyword
          placeholder="请输入关键词"
          :remote-method="getUserList"
          :loading="loading"
          @change="getUsers"
        >
          <el-option disabled="disabled" label="1" value="1">
            <div class="option">
              <span>用户名</span>
              <span>手机号</span>
            </div>
          </el-option>
          <el-option v-for="item in userList" :key="item.uuid" :label="item.name" :value="item.uuid">
            <div class="option">
              <span>{{ item.real_name }}</span>
              <span>{{ item.mobile }}</span>
            </div>
          </el-option>
        </el-select>
        <el-button :loading="uping" style="margin-left: 20px" type="primary" @click="clickInp">批量导入用户</el-button>
        <el-button style="margin-left: 20px" type="primary" @click="downTemp">下载导入模板</el-button>
        <input v-show="false" v-if="!uping" id="fileup" type="file" name="" value="" @change="getFile" />
        <div class="select-list">
          <span v-for="(item, i) in selects"
            >{{ item.real_name || item.mobile }} <i class="el-icon-close" @click="removeUser(i)"></i
          ></span>
        </div>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <el-button @click="$router.go(-1)">返回</el-button>
      </el-form-item>
    </el-form>

    <!-- <el-dialog title="收货地址" :visible.sync="dialogTableVisible">
          <el-table :data="gridData">
            <el-table-column property="date" label="日期" width="150"></el-table-column>
            <el-table-column property="name" label="姓名" width="200"></el-table-column>
            <el-table-column property="address" label="地址"></el-table-column>
          </el-table>
        </el-dialog> -->
  </div>
</template>

<script>
import imgUpload from "@/components/pub/imgUploadNormal.vue";
import imgUploads from "@/components/pub/supperUpload.vue";
import fullEdit from "@/components/pub/fulledit.vue";
import { getUserList } from "@/api/user.js";
import { certificateUserAdd, UserCertificateImport, CertificateTemplate } from "@/api/edu.js";
export default {
  components: {
    imgUpload,
    imgUploads,
    fullEdit,
  },
  data() {
    return {
      uping: false,
      selects: [],
      dates: [],
      loading: false,
      typeList: [],
      userList: [],
      ruleForm: {
        user_uuid: "",
      },
      rules: {
        user_uuid: [
          {
            required: true,
            message: "请选择用户",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {
    console.log();
    const row = this.$route.query;
    // if (row.uuid) {
    //     this.getDetail(row)
    // }

    this.getUserList("");
  },
  methods: {
    downTemp() {
      CertificateTemplate();
    },
    clickInp() {
      document.getElementById("fileup").click();
    },
    getFile(e) {
      console.log(e.target.files[0]);

      if (e && e.target.files) {
        const fd = new FormData();
        fd.append("file", e.target.files[0]);
        this.uping = true;
        UserCertificateImport(fd)
          .then((res) => {
            this.uping = false;
            if (res instanceof Array) {
              this.selects.push(...res);
            }
          })
          .catch((err) => {
            this.uping = false;
            this.$message.error("上传出错");
          });
      }
      // console.log(file)
    },
    getUsers(val) {
      const item = this.userList.find((it) => {
        return it.uuid == val;
      });
      this.selects.push(item);
    },
    removeUser(i) {
      this.selects.splice(i, 1);
    },
    async getDetail(row) {
      const res = await getLiveDetail(row.uuid);

      if (res) {
        if (res.cate instanceof Array) {
          res.cate_uuid = res.cate.map((it) => {
            return it.uuid;
          });
        }
        // if (res.banner) {
        //     if (!Array.isArray(res.banner)) {
        //         res.banner = JSON.parse(res.banner)
        //     }
        // }
        this.ruleForm = {
          ...res,
          dates: [res.start_time, res.end_time],
        };
        console.log(res);
      }
    },

    getUserList(keyword_search) {
      getUserList({
        keyword_search,
      }).then((res) => {
        if (res.data instanceof Array) {
          this.userList = res.data;
        }
      });
    },
    editSave(data, uuid) {
      editLive(data, uuid).then((res) => {
        console.log(res);
        if (res) {
          this.$message.success("编辑成功");

          this.$router.go(-1);
        }
      });
    },
    addSave(data) {
      certificateUserAdd(data).then((res) => {
        console.log(res);
        if (res) {
          this.$message.success("新增成功");

          this.$router.go(-1);
        }
      });
    },
    submitForm(formName) {
      if (this.selects.length == 0) {
        this.$message.warning("请选择用户");
        return;
      }
      const data = {
        user_uuid: this.selects.map((it) => {
          return it.uuid;
        }),
        certificate_uuid: this.$route.query.uuid,
      };
      if (this.ruleForm.uuid) {
        this.editSave(data, this.ruleForm.uuid);
      } else {
        this.addSave(data);
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped="scoped" lang="less">
.option {
  display: flex;

  & > span {
    width: 50%;
  }
}
.select-list {
  span {
    background-color: #3b97d759;
    margin-right: 10px;
    margin-bottom: 10px;
    display: inline-block;
    padding: 5px 10px;
    line-height: 1;
    border-radius: 10px;
  }
}
</style>
